import CountriesTotalBlock from "./CountriesTotalBlock";

export default CountriesTotalBlock;